import React from 'react';

const TooltipIcon = ({ className, style }) => (
    <svg className={className} style={style} width="18" height="18" viewBox="0 0 18 18">
        <circle id="Ellipse_2" data-name="Ellipse 2" cx="9" cy="9" r="9" fill="#4a0d6f"/>
        <text id="i" transform="translate(7.489 12.4)" fill="#fff" fontSize="10" fontFamily="Red Hat Display" fontWeight="700"><tspan x="0" y="0">i</tspan></text>
    </svg>
);

export default TooltipIcon;